import {combineReducers} from 'redux';
import user from './reducer-user';
import sidepanel from './reducer-sidepanel';
import products from './reducer-products';
import productDepotInfos from './reducer-product-depot-info';
import subSubCategories from './reducer-sub-sub-categories';
import depots from './reducer-depots';
import quotes from './reducer-quotes';
import invoices from './reducer-invoices';
import proformaInvoices from './reducer-proforma-invoices';
import purchaseOrders from './reducer-purchase-orders';
import purchaseOrderStatuses from './reducer-purchase-order-statuses';
import notifications from './reducer-notifications';
import createProgram from './reducer-create-program';
import programs from './reducer-programs';
import applications from './reducer-applications';
import rdwDateFilter from './reducer-date-filter';
import reduxDashboardWidgets from './reducer-dashboard-widgets';
import operatingCosts from './reducer-operating-costs';

const rootReducer = combineReducers({
  user,
  sidepanel,
  products,
  productDepotInfos,
  subSubCategories,
  depots,
  quotes,
  invoices,
  proformaInvoices,
  purchaseOrders,
  purchaseOrderStatuses,
  notifications,
  createProgram,
  programs,
  applications,
  reduxDashboardWidgets,
  rdwDateFilter,
  operatingCosts,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
